import axios from "axios";

const instance = axios.create({
  baseURL: "",
  timeout: 240000,
});

export default instance;
